var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiRrPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_563_2615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1398 0.861026C16.6299 0.351924 15.9388 0.065979 15.2183 0.065979C14.4977 0.065979 13.8066 0.351924 13.2968 0.861026L1.09876 13.059C0.74945 13.4064 0.472483 13.8195 0.283885 14.2746C0.0952868 14.7297 -0.00119848 15.2177 1.12359e-05 15.7103V17.25C1.12359e-05 17.4489 0.0790289 17.6397 0.219681 17.7804C0.360333 17.921 0.551099 18 0.750011 18H2.28976C2.78233 18.0014 3.27029 17.9051 3.72538 17.7166C4.18047 17.5281 4.59365 17.2513 4.94101 16.902L17.1398 4.70328C17.6486 4.19342 17.9344 3.5025 17.9344 2.78215C17.9344 2.0618 17.6486 1.37088 17.1398 0.861026ZM3.88051 15.8415C3.45751 16.2617 2.88598 16.4983 2.28976 16.5H1.50001V15.7103C1.49925 15.4147 1.55713 15.1219 1.67029 14.8489C1.78345 14.5758 1.94965 14.3279 2.15926 14.1195L11.4165 4.86228L13.1415 6.58728L3.88051 15.8415ZM16.0785 3.64278L14.199 5.52303L12.474 3.80178L14.3543 1.92153C14.4675 1.80851 14.6019 1.7189 14.7498 1.65783C14.8977 1.59676 15.0562 1.56542 15.2162 1.56559C15.3762 1.56577 15.5346 1.59746 15.6824 1.65885C15.8301 1.72024 15.9644 1.81014 16.0774 1.9234C16.1904 2.03667 16.28 2.17108 16.3411 2.31898C16.4022 2.46687 16.4335 2.62534 16.4333 2.78535C16.4331 2.94536 16.4015 3.10376 16.3401 3.25153C16.2787 3.39929 16.1888 3.53351 16.0755 3.64653L16.0785 3.64278Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_563_2615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrPencil);
export default __webpack_public_path__ + "static/media/fi-rr-pencil.2bca54794067d465574e2be51031eaa6.svg";
export { ForwardRef as ReactComponent };